export default __webpack_public_path__ + "static/25-3d6980e58f0a5339f4e19e9ec4746ae6.png";